import React, { useCallback, useEffect } from 'react';
import { ModalBox, useMediaQueryContext, useModalContext } from '@fourthwall/components';
import * as S from './AnalyticsReportLayout.styled';
const SidebarModal = ({ children, onClose }) => (React.createElement(ModalBox, { size: "small", withoutPadding: true, onClose: onClose }, children));
export const AnalyticsReportLayout = ({ children, toolbar, sidebar, isSidebarOpen = false, hideSidebar, }) => {
    const media = useMediaQueryContext();
    const { open, close } = useModalContext();
    const closeSidebar = useCallback(() => {
        if (hideSidebar) {
            hideSidebar();
        }
        close();
    }, [hideSidebar, close]);
    useEffect(() => {
        if (!media.tablet && isSidebarOpen) {
            open(SidebarModal, {
                children: sidebar,
                onClose: closeSidebar,
            });
        }
    }, [open, isSidebarOpen, sidebar, media.tablet, hideSidebar, closeSidebar]);
    const renderSidebar = () => {
        if (!sidebar || !media.tablet) {
            return null;
        }
        return (React.createElement(S.SidebarTrack, { visible: isSidebarOpen },
            React.createElement(S.SidebarPositioner, null,
                React.createElement(S.SidebarPanel, { visible: isSidebarOpen }, sidebar))));
    };
    return (React.createElement(S.Container, null,
        toolbar,
        React.createElement(S.Inner, null,
            React.createElement(S.Content, { hasAside: media.tablet && !!sidebar && isSidebarOpen }, children),
            renderSidebar())));
};
